// extracted by mini-css-extract-plugin
export default {"wrapper":"_87b14ad","preQuoteTitle":"_87bae443"};